import ResizeObserver from 'resize-observer-polyfill';

const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
        const pane = entry.target;
        const computedPaneStyles = window.getComputedStyle(pane);
        const paddingTop = computedPaneStyles.getPropertyValue('padding-top');
        const textElement = pane.querySelector('.pane__text');
        const textHeight = textElement.offsetHeight;
        const textComputedStyles = window.getComputedStyle(textElement);
        const textMarginBottom = textComputedStyles.getPropertyValue('margin-bottom');
        const imageHeight = pane.querySelector('.card__image').offsetHeight;
        const backgroundElement = pane.querySelector('.pane__background');

        backgroundElement.style.height = `calc(${paddingTop} + ${imageHeight}px)`;

        if (window.matchMedia(`(min-width: 992px)`).matches) {
            backgroundElement.style.height = `calc(${paddingTop} + ${textHeight}px + ${textMarginBottom} + ${imageHeight}px)`;
        }

    });
});

const heroPanes = Array.from(document.querySelectorAll('.pane--hero-slider'));
heroPanes.forEach((pane) => {
    resizeObserver.observe(pane);
})
